import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const LockIcon = ({ color, ...rest }: { color?: string; className?: string; [x: string]: unknown }) => {
  const { token } = useToken();
  const currentColor = color ?? token.colorText;
  return (
    <svg width="12px" height="16px" viewBox="0 0 12 16" version="1.1" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icons" transform="translate(-37.000000, -36.000000)" fill={currentColor} fillRule="nonzero">
          <path
            d="M48.6666563,42 L47.6666563,42 L47.6666563,40.6666563 C47.6666563,38.0934375 45.57325,36 43,36 C40.42675,36 38.3333437,38.0934375 38.3333437,40.6666563 L38.3333437,42 L37.3333437,42 C37.1490937,42 37,42.1490937 37,42.3333437 L37,50.6666875 C37,51.4020313 37.5979687,52 38.3333437,52 L47.6666875,52 C48.4020313,52 49,51.4020313 49,50.6666563 L49,42.3333437 C49,42.1490937 48.8509063,42 48.6666563,42 Z M43.9980625,48.9632188 C44.0084687,49.0572813 43.9782187,49.1516875 43.9150625,49.2223438 C43.8519062,49.2929688 43.7614063,49.3333437 43.6666875,49.3333437 L42.3333437,49.3333437 C42.238625,49.3333437 42.148125,49.2929688 42.0849688,49.2223438 C42.0218125,49.1517188 41.9915313,49.0573125 42.0019687,48.9632188 L42.21225,47.0722813 C41.8707813,46.8239063 41.6666875,46.431 41.6666875,46 C41.6666875,45.2646563 42.2646563,44.6666563 43.0000312,44.6666563 C43.7354062,44.6666563 44.333375,45.264625 44.333375,46 C44.333375,46.431 44.1292812,46.8239063 43.7878125,47.0722813 L43.9980625,48.9632188 Z M45.6666563,42 L40.3333437,42 L40.3333437,40.6666563 C40.3333437,39.1962812 41.529625,38 43,38 C44.470375,38 45.6666563,39.1962812 45.6666563,40.6666563 L45.6666563,42 L45.6666563,42 Z"
            id="Lock"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export default LockIcon;
